module.exports = __webpack_public_path__ + "static/media/submit.7896984d.svg";